import PropTypes from "prop-types";
import React from "react";
import { Redirect, Route } from "react-router-dom";

import { checkCognitoTokenExists, isAuthenticated } from "./authHelpers";

export const PrivateRoute = ({ component: Component, hash, ...rest }) => {
	return (
		<Route
			{...rest}
			render={({ location }) =>
				isAuthenticated(location) ? (
					<Component />
				) : (
					<Redirect
						to={{
							pathname: "/",
							search: window.location.search,
							state: { from: location },
							hash
						}}
					/>
				)
			}
		/>
	);
};

PrivateRoute.propTypes = {
	component: PropTypes.elementType.isRequired,
	hash: PropTypes.string
};

export const PublicOnlyRoute = ({ component: Component, hash, ...rest }) => {
	return (
		<Route
			{...rest}
			render={({ location }) =>
				!checkCognitoTokenExists() ? (
					<Component />
				) : (
					<Redirect
						to={{
							pathname: "/orderHistory",
							search: window.location.search,
							state: { from: location },
							hash
						}}
					/>
				)
			}
		/>
	);
};

PublicOnlyRoute.propTypes = {
	component: PropTypes.elementType.isRequired
};
